import Vue from 'vue';
import Vuex from 'vuex';
import { JobsStore } from './models/jobs/jobs.vuex';
import { UserStore } from './models/userdata/users.vuex';
import { ReferralStore } from './models/referrals/referrals.vuex';
import { SkillStore } from './models/skills/skills.vuex';
import { UtilityStore } from './models/utility/utility.vuex';
import { ForumStore } from './models/forum/forum.vuex';
import { UtmTrackerStore } from './models/utility/utmtracker.vuex';
import { PassportStore } from './models/useridentification/passport.vuex';
import { LicenceStore } from './models/userlicence/licence.vuex';
import { RoleSignup } from './models/RoleSignup/roleSignup.vuex';
import { DocumentStore } from './models/additionaldocuments/document.vuex';
import { SocialProfileStore } from './models/socialprofile/socialprofile.vuex';
import { TimesheetStore } from './models/timesheet/timesheet.vuex';
import { WorkPreferenceStore } from './models/workpreference/workpreference.vuex';
import { NotificationPreferenceStore } from './models/notificationpreference/notificationpreference.vuex';
import { ProtectedInformationStore } from './models/protectedinformation/protectedinformation.vuex'
import { ConfigStore } from './models/configs/clientconfigs.vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const tokenStore = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: (state: any) => {
    return state;
  },
  filter: (mutation) => {
    return [
      'users/setToken',
      'users/setRefreshToken',
      'users/setAuthStatus',
      'users/setEmail',
      'referrals/setGlobalRefCode',
    ].includes(mutation.type);
  },
});
Vue.config.devtools = true;

Vue.config.devtools = true;

Vue.config.devtools = true;

export const store = new Vuex.Store({
  state: {
    authenticated: false,
  },
  modules: {
    jobs: JobsStore.ExtractVuexModule(JobsStore),
    users: UserStore.ExtractVuexModule(UserStore),
    referrals: ReferralStore.ExtractVuexModule(ReferralStore),
    skills: SkillStore.ExtractVuexModule(SkillStore),
    passport: PassportStore.ExtractVuexModule(PassportStore),
    licence: LicenceStore.ExtractVuexModule(LicenceStore),
    utility: SkillStore.ExtractVuexModule(UtilityStore),
    forum: ForumStore.ExtractVuexModule(ForumStore),
    utmtracker: UtmTrackerStore.ExtractVuexModule(UtmTrackerStore),
    roleSignup: RoleSignup.ExtractVuexModule(RoleSignup),
    documents: DocumentStore.ExtractVuexModule(DocumentStore),
    socialprofiles: SocialProfileStore.ExtractVuexModule(SocialProfileStore),
    timesheet: TimesheetStore.ExtractVuexModule(TimesheetStore),
    workpreference: WorkPreferenceStore.ExtractVuexModule(WorkPreferenceStore),
    configs: ConfigStore.ExtractVuexModule(ConfigStore),
    notificationpreference: NotificationPreferenceStore.ExtractVuexModule(
      NotificationPreferenceStore,
    ),
    protectedinformation: ProtectedInformationStore.ExtractVuexModule(ProtectedInformationStore)
  },
  plugins: [tokenStore.plugin],
});

export const vxm = {
  jobs: JobsStore.CreateProxy(store, JobsStore),
  users: UserStore.CreateProxy(store, UserStore),
  referrals: ReferralStore.CreateProxy(store, ReferralStore),
  skills: SkillStore.CreateProxy(store, SkillStore),
  passport: PassportStore.CreateProxy(store, PassportStore),
  licence: LicenceStore.CreateProxy(store, LicenceStore),
  utility: SkillStore.CreateProxy(store, UtilityStore),
  forum: ForumStore.CreateProxy(store, ForumStore),
  utmtracker: UtmTrackerStore.CreateProxy(store, UtmTrackerStore),
  roleSignup: RoleSignup.CreateProxy(store, RoleSignup),
  documents: DocumentStore.CreateProxy(store, DocumentStore),
  socialprofiles: SocialProfileStore.CreateProxy(store, SocialProfileStore),
  timesheet: TimesheetStore.CreateProxy(store, TimesheetStore),
  workpreference: WorkPreferenceStore.CreateProxy(store, WorkPreferenceStore),
  configs: ConfigStore.CreateProxy(store, ConfigStore),
  notificationpreference: NotificationPreferenceStore.CreateProxy(
    store,
    NotificationPreferenceStore,
  ),
  protectedinformation: ProtectedInformationStore.CreateProxy(store,ProtectedInformationStore,)
};
